import request from '@/plugins/request';
import { IRelease } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/v6';
const $urlPull = '/admin/v6/actions/pull';
const $urlPublish = '/admin/v6/actions/publish';

interface IGetResult {
  releases: IRelease[];
  latestNightlyRelease: IRelease;
  latestStableRelease: IRelease;
}

interface IPullResult {
  latestNightlyVersion: string;
  latestStableVersion: string;
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  publish(version: string, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .post(`${$urlPublish}/${version}`)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  pull(success: (res: IPullResult) => void) {
    utils.loading(true);
    request
      .post($urlPull)
      .then((response: AxiosResponse<IPullResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
